import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-loupe-angular',
  template: `
    <p>
      loupe-angular works!
    </p>
  `,
  styles: [
  ]
})
export class LoupeAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
